import axios from 'axios';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import constants from '../../const.js'
import { Form, Button, Container, Row, Col, Alert } from 'react-bootstrap';
import Logo from '../common/logo.js';

const ForgotPassword = (props) => {

    const [email, setEmail] = useState({
        valid: true,
        value: ''
    });
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!email.value) {
            setError('Please enter your email address.');
            return;
        }
        setError('');
        setSuccess(false);
        // Call the API to send the reset password email
        await axios.post(`${constants.USER_API_URL}/auth/resetToken`, { email: email.value })
            .then(res => {
                if (res.status === 200) {
                    setSuccess(true);
                } else {
                    setError('Failed to send reset instructions. Please try again.');
                }
            }).catch(err => {
                console.error(err);
                setError('Failed to send reset instructions. Please try again.');
            });
    };

    return (
        <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
            <Row className="w-100">
                <Col md={{ span: 6, offset: 3 }}>
                    <div className="p-4 border rounded-5 shadow-sm bg-white">
                        <Logo />
                        <h2 className="text-center mb-4">Forgot Password</h2>
                        {error && <Alert variant="danger">{error}</Alert>}
                        {success && <Alert variant="success">Password reset instructions have been sent to your email.</Alert>}
                        {props.forgotPasswordError && (
                            <Alert variant="danger">Failed to send reset instructions. Please try again.</Alert>
                        )}
                        <Form onSubmit={handleSubmit}>
                            <Form.Group controlId="formEmail" className="mb-3">
                                <Form.Label>Email address</Form.Label>
                                <Form.Control
                                    type="email"
                                    placeholder="Enter your email"
                                    value={email.value}
                                    onChange={(e) => setEmail({ ...email, value: e.target.value })}
                                />
                            </Form.Group>
                            <Button variant="primary" type="submit" className="w-100">
                                Send Reset Instructions
                            </Button>
                        </Form>
                        <div className="text-center mt-3">
                            <Link to="/login">Back to Login</Link>
                        </div>
                    </div>
                </Col>
            </Row>
        </Container>
    );
}

export default ForgotPassword;